import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';

const styles = () => ({
  root: {
    flexGrow: 1,
  },
});

const SingleProjectSettingsPermissions = (props) => {
  const { classes } = props;
  return (
    <div className={classes.root}>
      <Typography>
        Enable or disable certain model features and choose access levels.
      </Typography>
    </div>
  );
};

SingleProjectSettingsPermissions.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(SingleProjectSettingsPermissions);
